import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import gql from 'graphql-tag';
import { orders } from '../utils/e-commerce/orders';

@Injectable()
export class BookingsQueryService {
    ordersValues = orders;

    public GET_ALL_SCHEDULE: any;
    public GET_OWN_SCHEDULE: any;
    public GET_BOOKING_BY_ORDERID_DATA: any;
    public GET_BOOKING_BASED_ON_ADDRESS: any;

    public UPDATE_SCHEDULE_BOOKING_BY_ORDERID_DATA: any;
    public UPDATE_SCHEDULE_BOOKING_BY_NODEID_DATA: any;

    public DELETE_SCHEDULE_BOOKING: any;

    constructor(public apollo: Apollo) {

        /*Get all schedule bookings*/
        this.GET_ALL_SCHEDULE = gql` 
            query{
                allScheduledBookings(orderBy:SCHEDULE_BOOKING_ID_ASC) {
                  edges {
                    node {
                      startTime
                      endTime
                      startAt
                      createdAt
                      notes
                      bookingStatus                     
                      color
                      endAt
                      scheduleBookingId                     
                      createdBy
                      assignedTo
                      firstName
                      lastName
                      buyerAgent
                      buyerProperty
                      orderType
                      realStart
                      userByAssignedTo {
                        firstName
                        lastName                        
                      }
                    }
                  }
                }
                }
            `;
        /*Get own schedule bookings*/
        this.GET_OWN_SCHEDULE = gql` 
    query getIcSchedule($userId:UUID!){
        allScheduledBookings(condition:{assignedTo:$userId}) {
          edges {
            node {
              startTime
              endTime
              startAt
              createdAt
              notes
              bookingStatus                   
              color
              endAt
              scheduleBookingId                     
              createdBy
              assignedTo
              firstName
              lastName
              buyerAgent
              buyerProperty
              orderType
              realStart
              userByAssignedTo {
                firstName
                lastName                        
              }
            }
          }
        }
        }
    `
            ;
        /*Get nodeId from booking for updating insReportId*/
        this.GET_BOOKING_BY_ORDERID_DATA =
            gql`                                
            query GetReturnSelectedId($orderId:Int!) {
            allScheduledBookings(condition:{scheduleBookingId:$orderId}) {
                edges {
                node {
                    nodeId
                    scheduleBookingId
                }
                }
            }
        }
    `;
        /*get all orders based on address*/
        this.GET_BOOKING_BASED_ON_ADDRESS = gql`
                query GetOrders($address:String) {
                    allScheduledBookings(condition: {buyerProperty:$address} ) {
                                edges {
                                    node {                                       
                                        createdAt                                                                                                                                                    
                                        assignedTo
                                        buyerProperty
                                        firstName
                                        lastName
                                        buyerAgent
                                        orderType
                                        insReportId
                                        scheduleBookingId

                                    }
                                }
                        }
                 }
                `;

        /*Update data of schedule booking*/
        this.UPDATE_SCHEDULE_BOOKING_BY_ORDERID_DATA = gql` 
                mutation updateScheduleBooking($input:UpdateScheduledBookingByScheduleBookingIdInput!){
                    updateScheduledBookingByScheduleBookingId(input:$input){
                        scheduledBookingEdge {
                            node {
                            insReportId                           
                            bookingStatus                                               
                            }
                        }
                }
                }
        `;
        //Update data of schedule booking's insReportId
        this.UPDATE_SCHEDULE_BOOKING_BY_NODEID_DATA =
            gql`                                
            mutation UPDATE_SCHEDULE_BOOKING_BY_ORDERID($input: UpdateScheduledBookingInput!) {
            updateScheduledBooking(input: $input) {
                scheduledBooking{
                        insReportId
                }
            }
            }   
            `;

        /*Delete booking by orderid */
        this.DELETE_SCHEDULE_BOOKING = gql` 
             mutation deleteBooking($input:DeleteScheduledBookingByScheduleBookingIdInput!){
                 deleteScheduledBookingByScheduleBookingId(input:$input){
                         deletedScheduledBookingId
                 }
             }
         `;

    }

    /*Get all schedule bookings*/
    GET_ALL_SCHEDULES() {
        return this.apollo.watchQuery({
            query: this.GET_ALL_SCHEDULE,
            fetchPolicy: 'network-only'
        })

    }
    /*Get own schedule bookings*/
    GET_OWN_SCHEDULES() {
        return this.apollo.watchQuery({
            query: this.GET_OWN_SCHEDULE,
            variables:
            {
                userId: window.localStorage.getItem("userUID"),
            },
            fetchPolicy: 'network-only'

        })
    }
    /*Get nodeId from booking for updating insReportId*/
    GET_SCHEDULE_BOOKING_BY_ORDERID(orderId) {
        return this.apollo.watchQuery({
            query: this.GET_BOOKING_BY_ORDERID_DATA,
            variables: {
                "orderId": Number.parseInt(orderId),
            },
            fetchPolicy: 'network-only'
        })
    }
    /*get all orders based on address*/
    GET_BOOKING_BY_ADDRESS(address): any {
        return this.apollo
            .watchQuery({
                query: this.GET_BOOKING_BASED_ON_ADDRESS
                ,
                variables:
                {
                    "address": address,
                },
                fetchPolicy: 'network-only'
            });
    }

    /*Update data of schedule booking once Ic assigned*/
    UPDATE_SCHEDULE_BOOKING_BY_ID(scheduleForm, scheduleId) {
        return this.apollo.mutate({
            mutation: this.UPDATE_SCHEDULE_BOOKING_BY_ORDERID_DATA,
            variables: {
                "input": {
                    "scheduledBookingPatch":
                    {
                        // "startAt": scheduleForm.get('start').value, currenly hided.bec time /date picker showen
                        // "endAt": scheduleForm.get('end').value,
                        // "allDay": scheduleForm.get('allDay').value,
                        // "color": JSON.stringify(scheduleForm.get('color').value),
                        // "startTime": scheduleForm.get('startTime').value,
                        // "endTime": scheduleForm.get('endTime').value,
                        "notes": scheduleForm.get('meta').value.notes,
                        "assignedTo": scheduleForm.get('assignedTo').value,
                        "bookingStatus": this.ordersValues.status.Allocated
                    },
                    "scheduleBookingId": scheduleId
                }

            },
            fetchPolicy: 'no-cache'
        })
    }
    UPDATE_SCHEDULE_BOOKING_BY_NODEID(randomId, nodeId) {
        return this.apollo.mutate({
            mutation: this.UPDATE_SCHEDULE_BOOKING_BY_NODEID_DATA,
            variables: {
                "input": {
                    "scheduledBookingPatch":
                    {
                        "insReportId": randomId
                    },
                    "nodeId": nodeId
                }
            },
            fetchPolicy: 'no-cache'
        })
    }


    UPDATE_SCHEDULE_BOOKING_BY_ORDERID(randomId, orderId) {
        return this.apollo.mutate({
            mutation: this.UPDATE_SCHEDULE_BOOKING_BY_ORDERID_DATA,
            variables: {
                "input": {
                    "scheduledBookingPatch":
                    {
                        "insReportId": randomId
                    },
                    "scheduleBookingId": orderId
                }
            },
            fetchPolicy: 'no-cache'
        })
    }

    /*Update data of schedule booking's insReportId*/
    UPDATE_SCHEDULE_BOOKING_BY_OWNER(nodeId, userId): any {

        return this.apollo.mutate({
            mutation: this.UPDATE_SCHEDULE_BOOKING_BY_NODEID_DATA,
            variables: {
                "input": {
                    "scheduledBookingPatch":
                    {
                        "bookingStatus": this.ordersValues.status.Allocated,
                        "assignedTo": userId,
                    },
                    "nodeId": nodeId
                }
            },
            fetchPolicy: 'no-cache'
        })
    }
    /*Delete booking by orderid */
    DELETE_BOOKING_BY_ORDER_ID(event) {
        return this.apollo.mutate({
            mutation: this.DELETE_SCHEDULE_BOOKING,
            variables: {
                "input": {
                    "scheduleBookingId": event.scheduleBookingId
                }
            }
        })
    }
}


// WEBPACK FOOTER //
// /vercel/path0/src/app/main/content/apps/queryFiles/scheduleBookings.ts